export default __webpack_public_path__ + "static/media/login-image.ed4590a2.png";